import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack, TextField } from "@mui/material";
import addFornitore from "../services/addFornitore";
import Cookies from 'universal-cookie';
import getFornitore from "../services/getFornitore";
import editFornitore from "../services/editFornitore";
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import MultiSelectSearch from "./MultiSelectSearch";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });
let userType = cookies.get('userType', { path: '/' });

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
};



export default class MyModal extends React.Component {
    constructor (props){
        super(props);

        this.state = {
            selectedDisposizione: [],
        }
        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' }
        ];
    }


    async componentDidMount() {{
        token = cookies.get('token', { path: '/' });
        username = cookies.get('username', { path: '/' });
        userType = cookies.get('userType', { path: '/' });

        if(this.props.modal.id) {
            let fornitore = await getFornitore(username, token, this.props.modal.id);
            this.setState({
                ragioneSociale: fornitore.ragione_sociale,
                p_iva: fornitore.p_iva,
                email: fornitore.email_ordini,
                selectedDisposizione: fornitore.disposizione_pagamenti ? JSON.parse(fornitore.disposizione_pagamenti) : [],
            });
        }
    }}

    async save() {
        var duplicateCodeErrorMessage = "Il codice fiscale/La partita IVA inserito risulta già definito per un altro fornitore.";
        var genericeErrorMessage = "Errore nella modifica del prodotto";

        if(!this.checkEmail()){
            alert('Inserisci un email valida') 
            return
        }

        if(this.state.p_iva.length !== 11){
            alert('Inserisci P.IVA o Codice Fiscale valido') 
            return
        }

        if (this.state.ragioneSociale.trim() !== "" && this.state.p_iva.length === 11 && this.checkEmail()) {
            if(this.props.modal.id) {
                editFornitore(username, token, this.state.ragioneSociale, this.state.p_iva, this.state.email, this.props.modal.id, JSON.stringify(this.state.selectedDisposizione)).then((res) => {
                    if (res.result === 'ok') {
                        this.props.onReload();
                        this.close();
                        return;
                    }
                    res.errore === duplicateCodeErrorMessage ? alert(res.errore) : alert(genericeErrorMessage);
                })
            } else {
                addFornitore(username, token, this.state.ragioneSociale, this.state.p_iva, this.state.email, JSON.stringify(this.state.selectedDisposizione)).then((res) => {
                    if (res.result === 'ok') {
                        this.props.onReload();
                        this.close();
                        return;
                    }
                    res.errore === duplicateCodeErrorMessage ? alert(res.errore) : alert(genericeErrorMessage);
                })
            }
        }
    }

    checkEmail() {
        if (/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.email)) {
            return true;
        }
        return false;
    }

    close() {
        this.props.onClose();
    }

    render (){
        return ( 
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={"column"} spacing={2} sx={{ flex: 1}}> 
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth inputProps={{ readOnly: (!this.props.isUserType) }} value={this.state.ragioneSociale} label="Ragione Sociale" variant="outlined" onChange={(e) => this.setState({ragioneSociale: e.target.value})}  InputLabelProps={{ shrink: this.state.ragioneSociale }} />
                        </Stack>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <TextField  fullWidth inputProps={{ readOnly: (!this.props.isUserType) }} value={this.state.p_iva} label="P. IVA / Codice Fiscale" variant="outlined" onChange={(e) => this.setState({p_iva: e.target.value})} InputLabelProps={{ shrink: this.state.p_iva }} />
                            <TextField fullWidth inputProps={{ readOnly: (!this.props.isUserType) }} value={this.state.email} label="Email" variant="outlined" onChange={(e) => this.setState({email: e.target.value})} InputLabelProps={{ shrink: this.state.email }} />
                        </Stack>  

                        <MultiSelectSearch readOnly={!this.props.isUserType } optionsArray={this.disposizioni} labelKey={'label'} label='Disposizioni pagamento' selectedValues={this.state.selectedDisposizione} onSelected={(e) => { this.setState({ selectedDisposizione: e })}} />

                        {
                            (this.props.isUserType) && <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>{this.props.modal.id ? "Modifica" : "Salva"}</LoadingButton>                            
                        }          
                    </Stack>
                </Box>
            </Modal>
        )
    }
}